import React, { useEffect } from 'react';
import * as ReactPixel from 'meta-pixel';
const PIXEL_ID = '2159795448128813';
export function MetaPixel() {
  useEffect(() => {
    ReactPixel.init(PIXEL_ID);
    ReactPixel.pageView();
  }, []);
  return null;
}